"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var utilities_1 = require("@sportnet/utilities");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var widgets_1 = tslib_1.__importDefault(require("../../../view/widgets"));
var SubContent = styled_components_1["default"](function (props) { return react_1["default"].createElement(widgets_1["default"], tslib_1.__assign({}, props)); })(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  & > div {\n    padding: 0;\n  }\n  & > div:first-child {\n    margin-top: 0;\n  }\n"], ["\n  & > div {\n    padding: 0;\n  }\n  & > div:first-child {\n    margin-top: 0;\n  }\n"])));
var EntityReference = function (_a) {
    var _b = _a.data, data = _b === void 0 ? {} : _b, renderEmpty = _a.renderEmpty, renderLink = _a.renderLink, override = _a.override;
    var content = utilities_1.getProp(data, ['data', 'content'], []);
    if (content.length === 0) {
        if (renderEmpty) {
            return react_1["default"].createElement(react_1["default"].Fragment, null, renderEmpty('entityReference'));
        }
        return null;
    }
    return (react_1["default"].createElement(SubContent, { items: content, renderLink: renderLink, renderEmpty: renderEmpty, override: override }));
};
exports["default"] = EntityReference;
var templateObject_1;
